module.exports = __webpack_public_path__ + "img/video.3b59d061.png";